import { render, staticRenderFns } from "./contacter.vue?vue&type=template&id=2bfe3d79&scoped=true&"
import script from "./contacter.vue?vue&type=script&lang=js&"
export * from "./contacter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe3d79",
  null
  
)

export default component.exports